type Props = {
  message: string;
  onRetry?: () => void;
};

export const ErrorState = ({ message, onRetry }: Props) => (
  <div className="rounded-xl border border-neon-red/40 bg-neon-red/10 p-4 text-neon-red">
    <p className="font-semibold">Something went wrong</p>
    <p className="text-sm">{message}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="mt-4 rounded border border-neon-red/50 px-3 py-1 text-xs font-semibold text-text-primary hover:bg-neon-red/20 transition-colors"
      >
        Retry
      </button>
    )}
  </div>
);

